const ADMIN = require('./admin.png');
const HEART = require('./heart.png');
const LOVEBOX = require('./lovebox.png');
const POSTCARD = require('./postcard.png');
const SEND = require('./send_arrow.png');
const EMPTY_COVER = require('./empty_cover.png');

export {
  ADMIN,
  HEART,
  LOVEBOX,
  POSTCARD,
  SEND,
  EMPTY_COVER,
};



// WEBPACK FOOTER //
// ./src/assets/Images.js